module.exports = __webpack_public_path__ + "img/spetema-small.d1f83376.svg";